import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Shipment} from "../services/shipment";
import {ShipmentsService} from "../services/shipments.service";

@Component({
    selector: 'app-shipment-state',
    templateUrl: './shipment-state.component.html',
    styleUrls: ['./shipment-state.component.sass'],
})
export class ShipmentStateComponent implements OnInit {

    public shipmentId: string;
    public shipment: Shipment;

    public error = false;

    constructor(public shipmentsService: ShipmentsService,
                public activatedRoute: ActivatedRoute,
                public router: Router) {
        this.shipmentId = activatedRoute.snapshot.params.shipmentId;
    }

    ngOnInit() {
        this.shipmentsService.getShipment(this.shipmentId, {}).then((response) => {
            this.shipment = response;
        }).catch((_: any) => {
            this.error = true;
        });
    }
}
